<template>
  <div>
    <div class="grid" v-for="item in availableAuthorizations" :key="item.id"
      :ref="item.key === suggestedAuthType ? 'suggestedRule' : undefined"
      :class="{ 'suggested-rule': item.key === suggestedAuthType }"
      :data-testid="item.key === suggestedAuthType ? 'applied-rules-suggested-type' : undefined">
      <div class="col">
        <p class="text-lg font-bold m-0">
          {{ item.name }}
        </p>
        <p class="role-property-description" :style="{ color: '#999999' }">
          {{ AUTH_RULES[item.key] ?? 'Description is not available' }}
        </p>
        <p v-if="item.key === suggestedAuthType" class="suggested-rule-helper">
          Suggested for review after repeated approvals for this violation type.
        </p>
      </div>
      <div class="col-fixed">
        <a-switch :disabled="isDisabled" :checked="hasAuthorization(item.key)" @change="handleSwitchChange(item)" />
      </div>
    </div>
  </div>
</template>

<script>
import { Switch } from 'ant-design-vue'
import AuthReasonMixin from '@/modules/authorizations/mixins/AuthReasonMixin'

export default {
  components: {
    'a-switch': Switch
  },
  props: {
    authorizations: {
      type: Array,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    suggestedAuthType: {
      type: String,
      default: undefined
    }
  },
  mixins: [AuthReasonMixin],
  computed: {
    availableAuthorizations() {
      return this.$store.state.applicationState.extendedShiftAuthTypes
    }
  },
  watch: {
    suggestedAuthType: {
      handler: 'scrollToSuggestedRule',
      immediate: true
    },
    availableAuthorizations: 'scrollToSuggestedRule'
  },
  methods: {
    scrollToSuggestedRule() {
      if (!this.suggestedAuthType) return
      this.$nextTick(() => {
        const refs = this.$refs.suggestedRule
        const row = Array.isArray(refs) ? refs[0] : refs
        row?.scrollIntoView({ block: 'nearest' })
      })
    },
    hasAuthorization(key) {
      return this.authorizations.includes(key)
    },

    handleSwitchChange(item) {
      const updatedAuthorizations = this.hasAuthorization(item.key)
        ? this.authorizations.filter(roleItem => roleItem !== item.key)
        : [...this.authorizations, item.key]

      this.$emit('update:authorizations', updatedAuthorizations)
    }
  }
}
</script>

<style scoped>
.suggested-rule {
  background: #f0f5ff;
  border-left: 3px solid #adc6ff;
  border-radius: 4px;
  padding: 8px;
}

.suggested-rule-helper {
  color: #434343;
  margin: 0;
}
</style>
